import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Col, Form, Row, Button, Table, Modal,
} from 'react-bootstrap';
import Moment from 'react-moment';
import { getUserLoginHistory } from '../../actions/userLogActions';
import {
  getTransactionHistory, clearTransactionHistory, getTransactionDetails, clearTransactionDetails,
} from '../../actions/doosraCash';
import TransactionDetails from './Index';
import Pagination from '../subLevel/Pagination';

const crossImg = require('../../assets/cross.svg');

class TransactionComponent extends Component {
  constructor() {
    super();
    this.state = {
      searchBy: 'email',
      searchValue: '',
      error: '',
      show: false,
      pageNo: 1,
      pageSize: 10,
      transactionData: [],
      totalPages: null,
      error: '',
    };
    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  componentDidMount() {
    if (this.props.history.location.state) {
      const data = this.props.history.location.state;
      this.setState({
        searchBy: data.searchBy,
        searchValue: data.searchValue,
        pageNo: this.state.pageNo,
        pageSize: this.state.pageSize,
      });

      this.props.getTransactionHistory(data)
        .then((resp) => {
          this.setState({
            transactionData: resp.list,
            pageNo: resp.pageNo,
            pageSize: resp.pageSize,
            totalPages: resp.totalPages,
          });
        })
        .catch((err) => {
          this.setState({
            error: err,
          });
        });
    } else {
      this.props.getTransactionHistory({
        pageNo: this.state.pageNo,
        pageSize: this.state.pageSize,
      }).then((resp) => {
        this.setState({
          transactionData: resp.list,
          pageNo: resp.pageNo,
          pageSize: resp.pageSize,
          totalPages: resp.totalPages,
        });
      })
        .catch((err) => {
          this.setState({
            error: err,
          });
        });
    }
  }

  handleClose() {
    this.setState({ show: false });
    this.props.clearTransactionDetails();
  }

  handleShow(id) {
    this.setState({ show: true });

    this.props.getTransactionDetails({ transactionId: id });
  }

  onChange = (e) => {
    this.setState({ [e.target.id]: e.target.value });
    // this.props.clearTransactionDetails();
  }

  onSubmit = (e) => {
    e.preventDefault();
    // if (this.state.userId == '') return;
    // console.log(this.state);
    if (!this.state.searchValue) return this.setState({ error: 'no search value provided' });
    const searchData = {
      searchBy: this.state.searchBy,
      searchValue: this.state.searchValue,
      pageNo: 1,
      pageSize: 10,
    };
    this.props.getTransactionHistory(searchData)
      .then((resp) => {
        this.setState({
          transactionData: resp.list,
          pageNo: resp.pageNo,
          pageSize: resp.pageSize,
          totalPages: resp.totalPages,
        });
      })
      .catch((err) => {
        this.setState({
          error: err,
          transactionData: [],
        });
      });
    this.setState({ error: '' });
  }

  switchPage = (searchData) => {
    // if (!searchData) {

    // }
    if (this.state.searchValue != '') {
      searchData.searchBy = this.state.searchBy;
      searchData.searchValue = this.state.searchValue;
    }

    this.setState({ transactionData: [] });
    this.props.getTransactionHistory(searchData)
      .then((resp) => {
        this.setState({
          transactionData: resp.list,
          pageNo: resp.pageNo,
          pageSize: resp.pageSize,
          totalPages: resp.totalPages,
        });
      })
      .catch((err) => {
        this.setState({
          error: err,
        });
      });
  }

  resetList = (e) => {
    e.preventDefault();
    this.props.clearTransactionHistory();
    this.setState({
      error: '',
      transactionData: [],
      searchValue: '',
    });
  }

  getQuantity = (amount, validity, i) => {
    if (i === 'CASH') return `${amount} INR`;
    if (i === 'VALIDITY') return `${validity} Days`;
    return '-';
  }

  render() {
    let transactions_list;
    // let displayHistory;
    // if (this.props.doosraCashTransactions) {
    //   displayHistory = this.props.doosraCashTransactions.map((transaction) => (
    //     <TransactionDetails {...transaction} />
    //   ))
    // }

    if (this.state.transactionData) {
      transactions_list = this.state.transactionData.map(((entry) => (
        <tr key={entry._id}>
          <td><Moment format="DD-MMM-YY h:mm a">{entry.created_at}</Moment></td>
          <td><a>{entry._id}</a></td>
          <td>{(entry.user && entry.user.v_mobile_no) ? entry.user.v_mobile_no : null}</td>
          <td>{entry.reference_method}</td>
          <td>{entry?.reference_details?.despose_details?.reward_type}</td>
          <td>
            {' '}
            {this.getQuantity(entry?.amount, entry?.validity, entry?.reference_details?.despose_details?.reward_type)}
          </td>
          <td>{entry.entry}</td>
          <td>
            <Button onClick={() => this.handleShow(entry._id)}>
              {entry.status}
            </Button>
          </td>

        </tr>
      )));
    }

    return (
      <div>
        <h1>Rewards transactions</h1>
        <form onSubmit={this.onSubmit} onReset={this.resetList}>
          <label>Search By</label>
          <select id="searchBy" onChange={this.onChange} value={this.state.searchBy}>
            <option value="email">Email</option>
            <option value="zvrNumber">user number</option>
            <option value="doosraNumber">Doosra number</option>
            <option value="flight_id">Flight id</option>
            <option value="reference_method">Method</option>
            <option value="flight_name">Flight Name</option>
          </select>
          <input
            type={
              (this.state.searchBy == 'email')
                ? 'email' : 'text'
            }
            value={this.state.searchValue}
            onChange={this.onChange}
            id="searchValue"
          />
          <input type="submit" />
          <input type="reset" />

          <p style={{ color: 'red' }}>{this.state.error || this.props.errors}</p>
        </form>
        {
          // (this.state.searchValue) ?
          // <p>Results for <strong>{this.state.searchBy}</strong> : <strong>{this.state.searchValue}</strong> </p> : <p></p>
        }
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>Date</th>
              <th>Transaction_id</th>
              <th>Doosra number</th>
              <th>Event</th>
              <th>Reward</th>
              <th>Quantity</th>
              <th>Entry type</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {transactions_list}
          </tbody>

        </Table>
        <div>
          {
            (this.state.transactionData.length > 0)
              ? (
                <Pagination
                  currentPage={this.state.pageNo}
                  lastPage={this.state.totalPages}
                  getInfo={this.switchPage}
                />
              )
              : null
          }
        </div>

        <Modal
          show={this.state.show}
          onHide={this.handleClose}
          dialogClassName="modal-90w"
          aria-labelledby="example-custom-modal-styling-title"
        >
          <Modal.Header>
            <Modal.Title>Transaction Details</Modal.Title>

            <img className="cross-button" src={crossImg} onClick={this.handleClose} />
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col>
                <p>
                  <strong>ID :</strong>
                  {this.props.transactionDetails._id}
                </p>
                <p>
                  <strong>Amount : </strong>
                  {this.props.transactionDetails.amount}
                </p>
                <p>
                  <strong>Created at : </strong>
                  <Moment format="DD-MMM-YYYY">{this.props.transactionDetails.created_at}</Moment>
                </p>
                <p>
                  <strong>Updated at : </strong>
                  <Moment format="DD-MMM-YYYY">{this.props.transactionDetails.updated_at}</Moment>
                </p>

                <p>
                  <strong>Entry : </strong>
                  {this.props.transactionDetails.entry}
                </p>
                <p>
                  <strong>Method :</strong>
                  {this.props.transactionDetails.reference_method}
                </p>
                <p>
                  <strong>Amount Transferred:</strong>
                  {(this.props.transactionDetails.is_amount_transferred) ? 'YES' : 'NO'}
                </p>
                <p>
                  <strong>Scratch Card:</strong>
                  {(this.props.transactionDetails.is_scratch_card) ? 'YES' : 'NO'}
                </p>

                {(this.props.transactionDetails.user)
                  ? (
                    <>
                      <p>
                        <strong>User name : </strong>
                        {this.props.transactionDetails.user.zvr_name}
                      </p>
                      <p>
                        <strong>Users number:</strong>
                        {this.props.transactionDetails.user.zvr_mobile_no}
                      </p>
                      <p>
                        <strong>Email : </strong>
                        {this.props.transactionDetails.user.zvr_email}
                      </p>
                      {/* <p>
                        <strong>Business account : </strong>
                        {(this.props.transactionDetails.user.is_business_account) ? 'YES' : 'NO'}
                      </p> */}
                    </>
                  )
                  : <p />}
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleClose}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>

      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  doosraCashTransactions: state.doosraCash.transactionHistory,
  errors: state.doosraCash.errors,
  transactionDetails: state.doosraCash.transactionDetails,
});

export default connect(mapStateToProps, {
  getTransactionHistory, clearTransactionHistory, getTransactionDetails, clearTransactionDetails,
})(TransactionComponent);
